import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppHubService } from '../../../techopsv4/application-hub/app-hub.service';
import { PortfolioHubService } from '../../../techopsv4/services/portfolioHubV4Service';
import { environment } from '../../../../environments/environment';
import { SharedService } from '../../services/shared.service';
import { SharedAuthService } from '../../shared.auth.service';
import { MaintenanceService } from '../../../techopsv4/services/maintenanceService';
import { ToastrService } from 'ngx-toastr';
import { LandingHeaderLoaderStateService } from '../../services/landing-header-loader-state.service';

@Component({
    selector: 'app-header2',
    templateUrl: './header2.component.html',
    styleUrls: ['./header2.component.css'],
    standalone: false
})
export class Header2Component implements OnInit {
  @Input() path;
  @Input() appName;
  public userNameFullDetails;
  public userNameInitials;
  hrefShareFeedback: string;
  public selectedRoute: string;
  genericNotificationOnly :boolean;
  // isAdminRole: boolean = environment.isAdminRole;
  @ViewChild('notificationModal', { static: false }) notificationModal;
  @ViewChild('urgentActionReqModal', { static: false }) urgentActionReqModal;
  acccess = {
    hasAppEditorSecureGrpAccess: false,
    hasModelEditorSecureGrpAccess: false,
    hasAdminSecureGrpAccess: false
  }
  workQueuesRoles = [];
  formattedRole: string = '';
  showLoader: boolean;
  isFundingOwnerAdmin: boolean = false;
  fundingOwnerAccess: boolean;
  enterpriseInitiativesList: any = [];
  initiativeSubscription: any;
  notificationSubscription: any;
  notifications: any = [];
  refreshState: any;
  oldBucketDetails: any = [];
  showNotificationDetailPopup: boolean = false;
  notificationList: any = [];
  isProdEnv: boolean = false;
  isMenuOpen: boolean = false;
  menuItems: any = [];
  parentRoute: string = '';
  submenuList: Array<any> = [];
  submenuPosition = { top: 0, left: 0 };
  @ViewChild('menuWrapper', { static: false }) menuWrapper;
  hideTimer: any;
  submenuDirection: 'up' | 'down' = 'down'; // Default direction is down
  currentMenu: any = null; // Track the current menu item for submenu
  rulesEngineVisibility = false;
  constructor(
    private route: Router,
    private readonly activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    private portfolioHubService: PortfolioHubService,
    public sharedAuthService: SharedAuthService,
    private appHubService: AppHubService,
    private maintenanceService: MaintenanceService,
    public landingHeaderLoaderStateService: LandingHeaderLoaderStateService,
    public toaster: ToastrService,
  ) {
    if(!sessionStorage.getItem("UrgentNotificationShown"))
      sessionStorage.setItem("UrgentNotificationShown", 'false');
    route.events
      .pipe(
        filter((event: any) => {
          return event instanceof NavigationStart;
        })
      )
    this.route.events.subscribe((event: NavigationStart) => {
      if (event instanceof NavigationStart) {
        if (event['url'] && event['url'] == '/landing-page') {
          this.selectedRoute = 'landing-page';
        } else {
          this.checkCurrentPath(event['url']);
        }
        const msId = this.sharedAuthService.getMsid();
        this.userNameFullDetails = JSON.parse(sessionStorage.getItem('currentUser'));
        this.hrefShareFeedback = `mailto:techops_support@ds.uhc.com?subject=${this.userNameFullDetails.replace(/^"(.*)"$/, '$1')} (${msId}) has shared a Feedback!`;
        this.createInitials(this.userNameFullDetails);
      }
    });
    this.initiativeSubscription = this.maintenanceService.enabledInitiativeList.subscribe((data) => {
      this.enterpriseInitiativesList = data;
    });


  }
  ngOnDestroy() {

    if (this.initiativeSubscription) {
      this.initiativeSubscription.unsubscribe();
    }

  }
  createInitials(userNameFullDetails) {
    if (!userNameFullDetails) {
      this.userNameInitials = ''; // Default to an empty string if userNameFullDetails is null/undefined
      return;
    }
    const userName = String(userNameFullDetails).replace(/,/g, ''); // Ensure userNameFullDetails is a string
    const initialsArray = userName.match(/\b(\w)/g);
    const slicedArray = initialsArray?.length > 1 ? initialsArray.slice(0, 2) : initialsArray;
    this.userNameInitials = slicedArray ? slicedArray.join('') : ''; // Handle cases where initialsArray is null
  }

  ngOnInit(): void {
    this.initialiseData();
  }

  async initialiseData() {
    this.sharedAuthService.notificationSource.subscribe(data => {
      if (data) {
        this.getNotification();
        this.getNotificationList();
      }
    }, error => {
      console.error('Error in notification subscription', error);
      this.toaster.error(`Error fetching notifications`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
    });
    this.userNameFullDetails = JSON.parse(sessionStorage.getItem('currentUser'));
    this.createInitials(this.userNameFullDetails);
    await this.hasEditProductAccess();
    this.checkCurrentPath();
    this.maintenanceService.setEnabledInitiativesData();
    this.isProdEnv = environment.environmentName === 'Prod';
    this.getDynamicContentForHeader();

  }
  

  checkCurrentPath(url?: string) {
    const currentPath = url ? url : window.location.pathname;
    if (currentPath.includes('application-hub')) {
      this.selectedRoute = 'application-hub';
    }else if (currentPath.includes('reports')) {
      this.selectedRoute = 'reports';
      this.parentRoute = 'reports';
    }else if (currentPath.includes('portfolio-hub')) {
      this.selectedRoute = 'portfolio-hub';
    }else if (currentPath.includes('work-queues')) {
      this.selectedRoute = 'work-queues';
    }else if (currentPath.includes('maintenanceV4/forecast-management')){
      this.selectedRoute = 'maintenanceV4/forecast-management';
    }else if (currentPath.includes('maintenanceV4/Capital-Demand')){
      this.selectedRoute = 'maintenanceV4/Capital-Demand';
    }else if (currentPath.includes('reclassification/reclassification-request')){
      this.selectedRoute = 'reclassification/reclassification-request';
    }else if (currentPath.includes('video-library')){
      this.selectedRoute = 'video-library';
    }else if (currentPath.includes('maintenance/group')){
      this.parentRoute = 'maintenanceV4/maintenance';
      this.selectedRoute = 'maintenance/group';
    }else if (currentPath.includes('maintenance?selectedTab=lob')){
      this.parentRoute = 'maintenanceV4/maintenance';
      this.selectedRoute = 'maintenance?selectedTab=lob';
    }else if (currentPath.includes('maintenanceV4/initiatives')){
      this.selectedRoute = 'maintenanceV4/initiatives';
      this.parentRoute = 'maintenanceV4/maintenance';
    }else if (currentPath.includes('maintenanceV4/bulk')){
      this.selectedRoute = 'maintenanceV4/bulk';
      this.parentRoute = 'maintenanceV4/maintenance';
    }else if (currentPath.includes('product-home?q=Optum%20Capability%20Model')) {
      this.selectedRoute = 'product-home?q=Optum%20Capability%20Model';
      this.parentRoute = 'product-home';
    }else if (currentPath.includes('product-home?q=UHC%20Product%20Capability%20Model')) {
      this.selectedRoute = 'product-home?q=UHC%20Product%20Capability%20Model';
      this.parentRoute = 'product-home';
    }else if (currentPath.includes('product-home?q=Technology%20Capability%20Model')) {
      this.selectedRoute = 'product-home?q=Technology%20Capability%20Model';
      this.parentRoute = 'product-home';
    }else if (currentPath.includes('workforce-budget')){
      this.selectedRoute = 'workforce-budget';
      this.parentRoute = 'reports';
    }
  }

  async hasEditProductAccess() {
      this.showLoader = true;
      const msId = this.sharedAuthService.getMsid();
      const secureGroups = JSON.parse(sessionStorage.getItem('secureGroups'));
      if (msId) {
        this.sharedAuthService.getAccessData(msId, { 'secureGroups': secureGroups }).subscribe(accessData => {
          this.sharedAuthService.setAccessDetailsInSession(accessData);
          this.formattedRole = this.sharedAuthService.getAuthorizationForEA();
          this.rulesEngineVisibility = this.sharedAuthService.getRulesEngineVisibility();
          this.checkWorkQueueAccess(accessData);
          this.acccess.hasAdminSecureGrpAccess = this.sharedAuthService.checkAdminSGAccess();
          this.acccess.hasAppEditorSecureGrpAccess = this.sharedAuthService.checkAppEditorSGAccess();
          this.acccess.hasModelEditorSecureGrpAccess = this.sharedAuthService.checkModelEditorSGAccess();
          this.showLoader = false;
          this.getNotification();
          this.getNotificationList();
        }, error => {
          this.toaster.error(`Error fetching user access  details`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
          console.error(error);
          this.showLoader = false;
        });
      } else {
        this.showLoader = false;
      }
  }
  showNotificationPopup() {
    this.showNotificationDetailPopup = true;
    this.notificationModal.show();
  }
  closeNotificationModal() {
    this.showNotificationDetailPopup = false;
    this.notificationModal.hide();
  }

  showUregentActionPopup() {
    const currentPath = window.location.href;
    const flag = sessionStorage.getItem("UrgentNotificationShown");
    if ((flag == null || flag != 'true') && !currentPath.includes('wqOpen') && !currentPath.includes('admin-dashboard')) {
      sessionStorage.setItem("UrgentNotificationShown", 'true');
      this.urgentActionReqModal.show();
    }

  }

  checkWorkQueueAccess(accessData) {
    accessData && accessData['workQueueAccessDetails'].forEach(role => {
      this.workQueuesRoles.push(role['V_Role']);
    });
  }
  getNotification() {
    this.showLoader = true;
    const payload  ={
      "MSID": this.sharedAuthService.getMsid(),
      "SecureGroups": JSON.parse(sessionStorage.getItem('secureGroups'))
    }
    this.sharedService.getNotification(payload).subscribe((response) => {
      this.showLoader = false;
      this.notifications = response?.result?.notificationMaster ? response?.result?.notificationMaster : [];
      if (this.notifications.length > 0) {
        // Reset urgent details so we only show the latest urgent notifications
        this.oldBucketDetails = [];
        const WQNotification = this.notifications.filter(ele => ele.Content.toLowerCase() == "workqueues")
        const CDNotification = this.notifications.filter(ele => ele.Content.toLowerCase() == "capital demand")
        this.checkForOlderBucket(WQNotification);
        this.checkCDUrgentNotification(CDNotification);

        // Single popup for 1 or many urgent items
        if (this.oldBucketDetails.length > 0) {
          this.showUregentActionPopup();
        }
        
      }
    }, (error) => {
      this.showLoader = false;
    })
  }

  getNotificationList() {
    this.showLoader = true;
    const payload  ={
      "MSID": this.sharedAuthService.getMsid(),
      "SecureGroups": JSON.parse(sessionStorage.getItem('secureGroups'))
    }
    this.sharedService.getNotificationList(payload).subscribe((response) => {
      this.showLoader = false;
      this.notificationList = response?.result?.notificationMaster;
      if(this.notificationList && (this.notificationList.length == 0 || (this.notificationList.length == 1 && this.notificationList[0]?.Content.toLowerCase() == "generic notifications"))) {
        this.genericNotificationOnly = true;
      }else{
        this.genericNotificationOnly = false;
      }
    }, (error) => {
      this.showLoader = false;
    })

  }

  checkForOlderBucket(wqNotification) {
    if (wqNotification.length > 0) {
      const olderBucketNotifications = (wqNotification[0]?.notifications || []).filter(element => element?.oldBucket == true);
      this.appendUniqueUrgentNotifications(olderBucketNotifications);
    }
  }

  checkCDUrgentNotification(cdNotification) {
    // Capital Demand is considered urgent if any notification exists.
    if (!cdNotification || cdNotification.length === 0) {
      return;
    }

    for (const item of cdNotification) {
      this.appendUniqueUrgentNotifications(item?.notifications || []);
    }
  }

  private appendUniqueUrgentNotifications(items: any[]) {
    if (!items || items.length === 0) {
      return;
    }
    const existing: any[] = Array.isArray(this.oldBucketDetails) ? this.oldBucketDetails : [];
    const seen = new Set<string>();

    for (const item of existing) {
      seen.add(this.getUrgentNotificationKey(item));
    }
    for (const item of items) {
      const key = this.getUrgentNotificationKey(item);
      if (!seen.has(key)) {
        existing.push(item);
        seen.add(key);
      }
    }

    this.oldBucketDetails = existing;
  }

  private getUrgentNotificationKey(item: any): string {
    return String(item?.id ?? item?.Notification_message ?? JSON.stringify(item));
  }

  private isTruthyFlag(value: any): boolean {
    return value === true || value === 'true' || value === 1 || value === '1' || value === 'Y' || value === 'y';
  }

  private isCapitalDemandExpressedUrgent(notification: any): boolean {
    if (!notification) {
      return false;
    }

    const message = String(notification?.Notification_message ?? '').toLowerCase();
    if (message.includes('expressed') || message.includes('experessed')) {
      return true;
    }

    const possibleBucket = String(
      notification?.bucket ?? notification?.Bucket ?? notification?.status ?? notification?.Status ?? ''
    ).toLowerCase();
    if (possibleBucket.includes('expressed') || possibleBucket.includes('experessed')) {
      return true;
    }

    // Fallback: check common boolean flag shapes if backend provides a dedicated flag.
    return (
      this.isTruthyFlag(notification?.expressed) ||
      this.isTruthyFlag(notification?.isExpressed) ||
      this.isTruthyFlag(notification?.expressedBucket) ||
      this.isTruthyFlag(notification?.isExpressedBucket) ||
      this.isTruthyFlag(notification?.capitalDemandExpressed) ||
      this.isTruthyFlag(notification?.isCapitalDemandExpressed)
    );
  }

  redirectView(data, isSubmenu: boolean = false) {
    if (data && data.submenus && data.submenus.length > 0) {
      return false; // Prevent navigation if there are submenus
    }
    let value = data.Url_Path;
    this.selectedRoute = value;
    let queryParams = {};
    this.parentRoute = '';
    switch (value) {
      case 'application-hub':
        this.appHubService.applicationHubFromKnowYourFinances = false;
        break;
      case 'portfolio-hub':
        this.portfolioHubService.porfolioSelectedFromFinance = false;
        queryParams = { selectedTab: 'lob' };
        break;
      case 'work-queues':
        queryParams = { selectedTab: 'requests' };
        break;
       case 'reclassification/reclassification-request':
        const label='Submit a request'
        queryParams = { selectedTab: label.replace(/ /g, '-'),selectedReclass: 'appReclassification' };
        break;
      case 'product-home?q=Optum%20Capability%20Model':
        value = 'product-home';
        queryParams = { q: 'Optum Capability Model' };
        break;
      case 'product-home?q=Technology%20Capability%20Model':
        value = 'product-home';
        queryParams = { q: 'Technology Capability Model' };
        break;
      case 'product-home?q=UHC%20Product%20Capability%20Model':
        value = 'product-home';
        queryParams = { q: 'UHC Product Capability Model' };
        break;
      case 'maintenance?selectedTab=lob':
        value = 'maintenance';
        queryParams = { selectedTab: 'lob' };
        break;
      case 'maintenanceV4/Capital-Demand':
        const selectedTab = 'Investment Summary';
        queryParams = { selectedTab: selectedTab.replace(/ /g, '-') };
        break;
    }
    this.navigateToRoute(value, queryParams);
    if (isSubmenu) {
      this.parentRoute = this.currentMenu.Url_Path;
      this.currentMenu.showSubmenu = false; // Hide the submenu of the current menu item
    }
    this.isMenuOpen = false; // Close the menu after navigation
    this.submenuList = []; // Clear the submenu list
    this.currentMenu = null; // Clear the current menu item
  }

  navigateToRoute(route: string,queryParams: any = {}) {
    if(queryParams){
      this.route.navigate([{ outlets: { primary: route } }], { queryParams: queryParams });
    }else{
      this.route.navigate([{ outlets: { primary: route } }]);
    }
  }

  redirectToHome() {
    this.selectedRoute = 'landing-page';
    this.parentRoute = '';
    this.navigateToRoute('landing-page');
  }

  redirectToRelease() {
    this.parentRoute = '';
    this.selectedRoute = 'release-note';
    const queryParams = { selectedTab: 'release' };
    this.navigateToRoute('release-note', queryParams);
  }

  redirectToUserManual() {
    window.open(environment.docUrl + "user-guide/overview/");
  }

  toggleMenu(state: boolean) {
    this.isMenuOpen = state;
  }

  onMouseLeave(ev: MouseEvent){
    const nextE1 = ev.relatedTarget as HTMLElement | null;
    if(nextE1 && this.menuWrapper && !this.menuWrapper.nativeElement.contains(nextE1)){
      this.isMenuOpen = false;
      this.submenuList = []; // Clear the submenu list
    }
  }

  onSubmenuMouseLeave(){
    this.currentMenu.showSubmenu = false; // Hide the submenu of the current menu item
    this.submenuList = [];
  }

  showSubMenu(ev,item: any) {
    this.menuItems.forEach(menu => {menu.showSubmenu = false;}); // Hide all other submenus
    const target = ev.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    const filteredSubmenuList = this.removeDuplicateSubmenu(item.submenus, item?.Content); //removing duplicate data
    item.submenus = filteredSubmenuList;
    const submenuHeight = item.submenus.length * 36 // Adjust this value based on your submenu height
    const spaceBelow = window.innerHeight - rect.top;
    const spaceabove = rect.bottom;
    let top: number;
    if( spaceBelow >= submenuHeight || spaceBelow > spaceabove) {
      //open upwards
      top = rect.top;
      this.submenuDirection = 'down';
    }else {
      //open downwards
      top = rect.bottom - submenuHeight;
      this.submenuDirection = 'up';
    }
    this.submenuPosition = { top: top, left: rect.right};
    if(item.submenus.length){
      this.submenuList = item.submenus;
      item.showSubmenu = true;
    }
    this.currentMenu = item; // Set the current menu item
  }

  //Logic to remove duplicate records from sub menus
  removeDuplicateSubmenu(submenuList: Array<any>, tab: string = ''): Array<any> {
    if(!submenuList || submenuList.length === 0) {
      return [];
    }
    //duplicate removal logic
    const filterList:Array<any> = submenuList.filter((item, index) => submenuList.indexOf(item) === index);
    //added logic for Maintenance tab as we have check for some keys
    if(tab.toLowerCase() == 'maintenance'){
      const uniqueList = this.accessibilityCheckForSubmenu(filterList);
      return uniqueList;
    }
    return filterList;
  }

  //Added check for accessibility check for submenu
  accessibilityCheckForSubmenu(filterList: Array<any>){
    const uniqueList:Array<any> = filterList.filter((item)=>{
        if(item?.Content == 'Bulk Edit'){
          return this.checkForBulkAccess(item);
        }else if(item?.Content == 'Enterprise Initiative'){
          return this.checkForEnterpriseInitiative();
        }else if(item?.Content == 'Rules Engine'){
          return this.checkForRulesEngineAccess(item);
        }
        return true;
      });
    return uniqueList;
  }

  //Function to check access for Bulk Edit
  checkForBulkAccess(subItem: any){
    if(subItem.Content == 'Bulk Edit' && (this.acccess.hasAdminSecureGrpAccess || this.acccess.hasAppEditorSecureGrpAccess || this.acccess.hasModelEditorSecureGrpAccess)){
      // User has access to Bulk Edit
      return true;
    }
    return false;
  }

  //Function to check for Enterprise Initiative access
  checkForEnterpriseInitiative(){
    return this.enterpriseInitiativesList && this.enterpriseInitiativesList.length > 0;
  }
  
  //Function to check for Rules Engine Access
  checkForRulesEngineAccess(subItem: any){
    if(subItem.Content == 'Rules Engine' && this.rulesEngineVisibility){
      // User has access to Rules Engine
      return true;
    }
    return false;
  }

  hideSubMenu(item: any) {
    this.hideTimer = setTimeout(() => {
      if(this.currentMenu && this.currentMenu.submenus.length == 0) {
        item.showSubmenu = false;
        this.submenuList = [];
        this.currentMenu = null; // Clear the current menu item
      }
    }, 150); // Clear the submenu after a delay
  }

  getDynamicContentForHeader() {
    const reqBody = {
        "PageName": "Landing Page"
    };
    this.landingHeaderLoaderStateService.setHeaderDynamicContentLoaded(false);
    this.sharedService.getDynamicContent(reqBody).subscribe({
        next: resp => {
            const data = resp.fieldData;
            if (data) {
                this.menuItems = data?.landingPageMenu || [];
                console.log(resp); // Log the entire response for debugging
            }

            this.landingHeaderLoaderStateService.setHeaderDynamicContentLoaded(true);
        },
        error: err => {
          this.landingHeaderLoaderStateService.setHeaderDynamicContentLoaded(true);
          this.toaster.error(`Error fetching dynamic content`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
          console.log("Error while loading data", err);
        }
    });
  }

  redirectToContactUs() {
    this.redirectView({ Url_Path: 'contact-us' });
  }

  onScroll(event: any) {
    if(this.currentMenu)
      this.currentMenu.showSubmenu = false; // Hide the submenu of the current menu item
    this.submenuList = []; // Clear the submenu list
  }
}